import React from "react";

// GDPR marketing opt-in checkbox. Unticked by default. Used across all lead forms.
export default function MarketingConsent({ checked, onChange, testId = "marketing-consent", className = "", light = false }) {
  return (
    <label className={`flex items-start gap-3 cursor-pointer text-sm ${light ? "text-slate-300" : "text-slate-600"} ${className}`}>
      <input
        type="checkbox"
        data-testid={testId}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 rounded border-slate-300 text-orange focus:ring-orange shrink-0"
      />
      <span>I'd like to receive occasional emails with accounting tips, guides and updates from CASS. You can unsubscribe at any time.</span>
    </label>
  );
}
